import { Card, CardContent } from '@/components/ui/card';
import type { Position } from '@arrowise/shared';
import PositionListItem from './PositionListItem';

export interface PositionListProps {
    positions: Position[];
    teamId?: string;
    canManagePosition?: boolean;
}

export function PositionList({ positions, teamId, canManagePosition }: PositionListProps) {
    const empty = (!positions || positions.length === 0);

    if (empty) {
        return (
            <Card>
                <CardContent className="py-10 text-center text-muted-foreground">
                    {teamId ? 'No positions found for this team.' : 'No positions yet. Create your first position to get started.'}
                </CardContent>
            </Card>
        );
    }

    return (
        <div className="space-y-6">
            <div className="flex flex-col gap-3">
                {positions.map((position) => (
                    <PositionListItem
                        key={position.id}
                        position={position}
                        canManagePosition={canManagePosition}
                    />
                ))}
            </div>
        </div>
    );
}
